import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

/** Minimal error/success surfacing — this app has no global-alert component like
 * Portal-SPA; an Ionic toast is sufficient for a developer tool's error surface. */
@Injectable({ providedIn: 'root' })
export class ToastService {
  constructor(private toastCtrl: ToastController) { }

  async error(message: string): Promise<void> {
    const toast = await this.toastCtrl.create({
      message, duration: 4000, position: 'top', color: 'danger',
    });
    await toast.present();
  }

  async success(message: string): Promise<void> {
    const toast = await this.toastCtrl.create({
      message, duration: 2500, position: 'top', color: 'success',
    });
    await toast.present();
  }
}
